<template>
  <div v-if="hasAnyPermission('characteristic-item-name-view')" class="py-4 container-fluid">
    <ToastPrime position="bottom-left" />
    <div class="row">
      <!-- Character -->
      <div class="col-md-6">
        <div class="card" style="height: 100%">
          <div class="card-header py-3">
            <div class="row align-items-center justify-content-between">
              <div class="col">
                <ApiSearchableSelect v-model="table.searchItemName" :api-service="standarItemNameService.list"
                  :api-params="{ limit: optStandardItemName.limit, select: 1 }" search-key="search" :min-chars="3"
                  option-label="inc_item_name" option-value="inc_item_name" placeholder="Search Item Name" size="small"
                  class="select-sm" style="width: 60%" @select="onSelectItemName" />
              </div>
              <div class="col-auto">
                <div class="d-flex align-items-center">
                  <ButtonPrime v-if="hasAnyPermission('characteristic-item-name-create')" v-tooltip.top="'Add New'" icon="pi pi-plus" size="small" severity="primary"
                    class="mx-1 btn-square-sm" :disabled="!table.assignedInc || modalChar.onLoad"
                    @click="openAddModalChar" />
                  <ButtonPrime v-if="hasAnyPermission('characteristic-item-name-update-bulk')" v-tooltip.top="'Mass Update'" icon="pi pi-save" size="small"
                    :disabled="!table.assignedInc || modalBulkPoText.onLoad" severity="primary"
                    class="mx-1 btn-square-sm" @click="openModalUpdateChar" />
                  <ButtonSplitPrime size="small" :disabled="!table.assignedInc" class="mx-1 btn-h-sm"
                    :label="itemTypeFilter" :model="filterOptions" />
                </div>
              </div>
            </div>
          </div>

          <div style="height: 500px">
            <DataTable v-model:selection="selectedCharItemName" class="datatable-sm text-sm char-table" size="small"
              scrollable scroll-height="flex" :value="table.data" selection-mode="single"
              :meta-key-selection="metaKey" data-key="id" table-style="min-width: 40rem; table-layout: fixed"
              :row-class="rowClass" @row-select="getValFromCertRow">
              <Column header="M" header-class="bg-light text-center col-narrow" body-class="text-center col-narrow"
                :style="{ width: '40px' }">
                <template #body="row">
                  <Skeleton v-if="table.onLoad" />
                  <Checkbox v-else v-model="row.data.is_mandatory" binary :true-value="'YES'" :false-value="'NO'"
                    size="small" />
                </template>
              </Column>
              <Column header="Characteristic" header-class="bg-light" :style="{ minWidth: '160px' }">
                <template #body="row">
                  <Skeleton v-if="table.onLoad" />
                  <span v-else>{{ row.data.characteristic.characteristic }}</span>
                </template>
              </Column>
              <Column header="Type" header-class="bg-light" :style="{ width: '70px' }">
                <template #body="row">
                  <Skeleton v-if="table.onLoad" />
                  <span v-else>{{ row.data.type }}</span>
                </template>
              </Column>
              <Column header="Seq" header-class="bg-light" :style="{ width: '80px', minWidth: '80px' }">
                <template #body="row">
                  <Skeleton v-if="table.onLoad" />
                  <InputText v-else v-model="row.data.sequence" type="text" size="small" placeholder="Seq"
                    class="table-input-select" />
                </template>
              </Column>
              <Column header="Seq Shortdes" header-class="bg-light" :style="{ width: '125px', minWidth: '125px' }">
                <template #body="row">
                  <Skeleton v-if="table.onLoad" />
                  <InputText v-else v-model="row.data.sequence_shortdes" type="text" size="small" placeholder="Shortdes"
                    class="table-input-select" />
                </template>
              </Column>
              <Column header="Separator" header-class="bg-light" :style="{ width: '95px', minWidth: '95px' }">
                <template #body="row">
                  <Skeleton v-if="table.onLoad" />
                  <SelectPrime v-else v-model="row.data.separator" :options="sepatorOptions" option-label="name"
                    option-value="code" class="table-input-select" />
                </template>
              </Column>
              <Column header="Actions" header-class="bg-light text-center" body-class="text-center"
                :style="{ width: '80px', minWidth: '80px' }">
                <template v-if="table.onLoad" #body>
                  <Skeleton />
                </template>
                <template v-else #body="row">
                  <div v-if="row.data?.characteristic">
                    <ButtonPrime v-if="hasAnyPermission('characteristic-item-name-delete')" icon="pi pi-trash" outlined rounded severity="danger" size="small"
                      class="btn-trash-xs" @click="deleteCharItemName(row.data.id)" />
                  </div>
                  <div v-else></div>
                </template>
              </Column>
              <template #empty>
                <div class="text-center py-7">
                  <img src="/no_data.png" alt="No Data" style="width: 175px; height: 175px; opacity: 0.5;" />
                  <p class="text-muted mt-2">No Char Item found</p>
                </div>
              </template>
            </DataTable>
          </div>

          <div class="card-footer pb-0 d-flex justify-content-between align-items-center">
            <BasePagination v-model="table.page.current_page" :page-count="table.page.total_page" size="sm"
              @click="changePage('char')" />
            <p>
              {{ (table.page.current_page - 1) * table.page.per_page + table.data.length }} of {{ table.total }}
            </p>
          </div>
        </div>
      </div>

      <!-- Character Value -->
      <div class="col-md-6">
        <div v-if="hasAnyPermission('characteristic-item-name-view-char-value')"  class="card" style="height: 100%">
          <div class="card-header py-3">
            <div class="row align-items-center justify-content-between">
              <div class="col-auto">
                <h6 class="mb-0" :class="!selectedCharItemName ? 'text-muted' : ''">Char Value</h6>
              </div>
              <div class="col-5">
                <IconField>
                  <InputIcon class="pi pi-search" />
                  <InputText v-model="tableCharVal.search" placeholder="Type min 2 character" size="small"
                    class="rounded-pill" :disabled="!selectedCharItemName" style="width: 100%"
                    @input="onSearchCharValue" @keyup.enter="searchCharValueByQuery" />
                </IconField>
              </div>
              <div class="col-auto">
                <div class="d-flex align-items-center justify-content-end">
                  <div class="d-flex">
                    <ButtonSplitPrime v-tooltip.bottom="'Filter'" size="small" class="mx-1 btn-h-sm" icon="pi pi-filter"
                      :disabled="!selectedCharItemName" :model="CharValOption" />
                    <ButtonPrime v-if="hasAnyPermission('characteristic-item-name-replace-abbrv-char-value')" v-tooltip.bottom="'Replace Char Value'" icon="pi pi-copy" size="small"
                      class="mx-1 btn-square-sm" severity="primary" :disabled="!selectedCharItemName"
                      @click="openReplaceAbbrv" />
                    <ButtonPrime v-if="hasAnyPermission('characteristic-item-name-create-char-value')" v-tooltip.bottom="'Add Char Value'" icon="pi pi-plus" size="small"
                      class="mx-1 btn-square-sm" severity="primary" :disabled="!selectedCharItemName"
                      @click="openAddCharValModal" />
                    <ButtonPrime v-if="hasAnyPermission('characteristic-item-name-update-bulk-char-value')" v-tooltip.bottom="'Save Char Value'" icon="pi pi-save" size="small"
                      class="mx-1 btn-square-sm" severity="primary" :disabled="!selectedCharItemName"
                      @click="openModalUpdateCharVal" />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div style="height: 500px">
            <DataTable :value="tableCharVal.data" class="datatable-sm text-sm char-val-table" size="small" scrollable
              scroll-height="flex" table-style="min-width: 26rem; table-layout: fixed">
              <Column header="Char Value" header-class="bg-light" :style="{ width: '160px', minWidth: '160px' }">
                <template #body="rowVal">
                  <Skeleton v-if="tableCharVal.onLoad" />
                  <AutoComplete v-else v-model="rowVal.data.characteristic_value" :suggestions="charValueSuggestions"
                    placeholder="Type to search..." size="small" fluid class="table-input-select" @complete="searchCharValueForRow($event)" />
                </template>
              </Column>
              <Column :style="{ width: '20px' }" header-class="bg-light text-center col-narrow"
                body-class="text-center col-narrow" :sortable="false">
                <template #header>
                  <i class="fa fa-arrow-right"></i>
                </template>
                <template #body="rowVal">
                  <Skeleton v-if="tableCharVal.onLoad && !rowVal.data.characteristic_value" />
                  <span v-else class="fa fa-arrow-right cursor-pointer" @click="copyCharVal(rowVal.data)"></span>
                </template>
              </Column>
              <Column header="Abbrev" header-class="bg-light" :style="{ width: '85px', minWidth: '85px' }">
                <template #body="rowVal">
                  <Skeleton v-if="tableCharVal.onLoad" />
                  <InputText v-else v-model="rowVal.data.abbreviation" type="text" size="small"
                    placeholder="Abbreviation" class="table-input-select" />
                </template>
              </Column>
              <Column header="Count" header-class="bg-light text-center" body-class="text-center" sortable
                :style="{ width: '70px' }">
                <template #body="rowVal">
                  <Skeleton v-if="tableCharVal.onLoad" />
                  <span v-else>{{ rowVal.data?.eu_part_characteristic_value?.length || 0 }}</span>
                </template>
              </Column>
              <Column header="Actions" header-class="bg-light text-center" body-class="text-center"
                :style="{ width: '80px', minWidth: '80px' }">
                <template v-if="table.onLoad" #body>
                  <Skeleton />
                </template>
                <template v-else #body="rowVal">
                  <div v-if="rowVal.data?.characteristic_value">
                    <ButtonPrime v-if="hasAnyPermission('characteristic-item-name-delete-char-value')" icon="pi pi-trash" outlined rounded severity="danger" size="small"
                      class="btn-trash-xs" @click="deleteItemCharVal(rowVal.data.id)" />
                  </div>
                  <div v-else></div>
                </template>
              </Column>
              <template #empty>
                <div class="text-center py-7">
                  <img src="/no_data.png" alt="No Data" style="width: 175px; height: 175px; opacity: 0.5;" />
                  <p class="text-muted mt-2">No Char found</p>
                </div>
              </template>
            </DataTable>
          </div>
          <div class="card-footer pb-0 d-flex justify-content-between align-items-center">
            <BasePagination v-model="tableCharVal.page.current_page" :page-count="tableCharVal.page.total_page"
              size="sm" @click="changePage('char_val')" />
            <p>
              {{ (tableCharVal.page.current_page - 1) * tableCharVal.page.per_page + tableCharVal.data.length }} of
              {{ tableCharVal.total }}
            </p>
          </div>
        </div>
        <NoAccess v-else />
      </div>

      <!-- Modal Add Char Item Name -->
      <DialogPrime v-model:visible="modalChar.visible" style="width: 30rem; margin: 10px;">
        <template #header>
          <div class="d-flex align-items-center gap-3">
            <div>
              <h5 class="mb-0 fw-bold text-dark">{{ modalChar.title }}</h5>
            </div>
          </div>
        </template>
        <div class="mb-1">
          <label for="characteristic_modal">Characteristic Master <span class="text-danger">*</span></label>
          <SelectPrime id="characteristic_modal" v-model="modalChar.data.selectedChar" editable :options="optCharMaster"
            option-label="characteristic" placeholder="Type min 3 chars to search..." size="small" class="w-full"
            :invalid="modalChar.errorMessage['characteristic'] && !modalChar.data.characteristic_code_desc" fluid
            @change="filterCharMaster"
            @hide="!modalChar.data.characteristic_code_desc && (modalChar.data.selectedChar = null)" />
          <small v-if="modalChar.errorMessage['characteristic'] && !modalChar.data.characteristic_code_desc"
            class="text-danger">{{ modalChar.errorMessage['characteristic'] }}</small>
        </div>
        <div class="row mb-0">
          <div class="col-4">
            <label for="sequence_modal">Sequence <span class="text-danger">*</span></label>
            <InputNumber id="sequence_modal" v-model="modalChar.data.sequence" placeholder="Sequence" size="small"
              input-id="withoutgrouping" :use-grouping="false"
              :invalid="modalChar.errorMessage['sequence'] && modalChar.data.sequence === ''" fluid />
            <small v-if="modalChar.errorMessage['sequence'] && modalChar.data.sequence === ''" class="text-danger">{{
              modalChar.errorMessage['sequence'] }}</small>
          </div>
          <div class="col-4">
            <label for="sequence_shortdes">Seq Shortdes <span class="text-danger">*</span></label>
            <InputNumber id="sequence_shortdes_modal" v-model="modalChar.data.sequence_shortdes"
              placeholder="Sequence Short Desc" size="small" input-id="withoutgrouping" :use-grouping="false"
              :invalid="modalChar.errorMessage['sequence_shortdes'] && modalChar.data.sequence_shortdes === ''" fluid />
            <small v-if="modalChar.errorMessage['sequence_shortdes'] && modalChar.data.sequence_shortdes === ''"
              class="text-danger">{{ modalChar.errorMessage['sequence_shortdes'] }}</small>
          </div>
          <div class="col-4">
            <label for="separator_modal">Separator <span class="text-danger">*</span> </label>
            <SelectPrime id="separator_modal" v-model="modalChar.data.separator" :options="sepatorOptions"
              option-label="name" option-value="code" placeholder=";" size="small" class="w-full"
              :invalid="modalChar.errorMessage['separator'] && modalChar.data.separator === ''" fluid />
            <small v-if="modalChar.errorMessage['separator'] && modalChar.data.separator === ''" class="text-danger">{{
              modalChar.errorMessage['separator'] }}</small>
          </div>
        </div>
        <div class="row mb-0">
          <div class="col-md-6 col-sm-12">
            <label for="type_modal">Type <span class="text-danger">*</span></label>
            <SelectPrime id="type_modal" v-model="modalChar.data.type" :options="typeOptions" option-label="label"
              option-value="value" placeholder="Choose type" size="small" class="w-full"
              :invalid="modalChar.errorMessage['type'] && modalChar.data.type === ''" fluid />
            <small v-if="modalChar.errorMessage['type'] && modalChar.data.type === ''" class="text-danger">{{
              modalChar.errorMessage['type'] }}</small>
          </div>
          <div class="col-md-6 col-sm-12">
            <label for="mandatory_modal">Mandatory ?</label>
            <div class="d-flex align-items-center">
              <ToggleSwitch id="mandatory_modal" v-model="modalChar.data.is_mandatory" :true-value="'YES'"
                :false-value="'NO'" />
              <label for="mandatory_modal" class="ms-2 mb-0">{{ modalChar.data.is_mandatory === 'YES' ? 'Yes' : 'No'
                }}</label>
            </div>
          </div>
        </div>

        <template #footer>
          <div class="d-flex justify-content-end gap-1 pt-2 border-top w-100 px-1">
            <ButtonPrime type="button" label="Cancel" style="min-width: 85px" severity="danger" raised size="small"
              :disabled="modalChar.onLoad" @click="modalChar.visible = false"></ButtonPrime>
            <ButtonPrime type="button" severity="contrast" raised size="small" label="Save" style="min-width: 85px"
              :disabled="modalChar.onLoad || anyEmptyVal" @click="saveChar()">
              <template v-if="modalChar.onLoad" #icon>
                <i class="fas fa-spinner fa-spin me-2"></i>
              </template>
            </ButtonPrime>
          </div>
        </template>
      </DialogPrime>

      <!-- Modal update material po text -->
      <DialogPrime v-model:visible="modalBulkPoText.visible" modal style="width: 30rem; margin: 10px;"
        class="client-modal" header="Update Characteristics">
        <div class="">
          <small>Are you sure you want to update all characteristics?</small>
        </div>
        <template #footer>
          <div class="d-flex justify-content-end gap-2 pt-3 border-top w-100 mt-2 px-1">
            <ButtonPrime type="button" label="Cancel" severity="danger" raised size="small"
              :disabled="modalBulkPoText.onLoad" @click="modalBulkPoText.visible = false"></ButtonPrime>
            <ButtonPrime type="button" severity="contrast" raised size="small" label="Update" class="px-4"
              :disabled="modalBulkPoText.onLoad" @click="updateBulk()">
              <template v-if="modalBulkPoText.onLoad" #icon>
                <i class="fas fa-spinner fa-spin me-2"></i>
              </template>
            </ButtonPrime>
          </div>
        </template>
      </DialogPrime>

      <!-- Modal Add Char Val -->
      <DialogPrime v-model:visible="modalCharValue.visible" :header="modalCharValue.title"
        style="width: 35rem; margin: 10px;">
        <template #header>
          <div class="d-flex align-items-center gap-3">
            <div>
              <h5 class="mb-0 fw-bold text-dark">{{ modalCharValue.title }}</h5>
            </div>
          </div>
        </template>
        <div class="mb-2">
          <label for="characteristic_val_modal">Sample Answer <span class="text-danger">*</span></label>
          <InputText id="characteristic_val_modal" v-model="modalCharValue.data.characteristic_value"
            placeholder="Sample Answer"
            :class="modalCharValue.errorMessage['characteristic_value'] && modalCharValue.data.characteristic_value === '' ? 'border-danger' : ''"
            fluid />
          <small
            v-if="modalCharValue.errorMessage['characteristic_value'] && modalCharValue.data.characteristic_value == ''"
            class="text-danger">{{ modalCharValue.errorMessage['characteristic_value'] }}</small>
        </div>
        <div class="mb-2">
          <label for="abbreviation_modal">Abbreviation </label>
          <InputText id="abbreviation_modal" v-model="modalCharValue.data.abbreviation" placeholder="Abbreviation"
            fluid />
        </div>
        <div class="">
          <label for="approval_modal">Approval <span class="text-danger">*</span></label>
          <SelectPrime id="approval_modal" v-model="modalCharValue.data.approved" :options="approvalOption"
            option-label="label" option-value="value" placeholder="Approve?" class="w-full md:w-56"
            :invalid="modalCharValue.errorMessage['approved'] && modalCharValue.data.approved === ''" fluid />
          <small v-if="modalCharValue.errorMessage['approved'] && modalCharValue.data.approved === ''"
            class="text-danger">{{
              modalCharValue.errorMessage['approved'] }}</small>
        </div>
        <template #footer>
          <div class="d-flex justify-content-end gap-2 pt-3 border-top w-100 mt-2 px-1">
            <ButtonPrime type="button" label="Cancel" severity="danger" raised size="small" class="px-4 border-0"
              :disabled="modalCharValue.onLoad" @click="modalCharValue.visible = false" />
            <ButtonPrime type="button" severity="contrast" raised size="small" label="Save" class="px-4"
              :disabled="modalCharValue.onLoad || !modalCharValue.data.characteristic_value || modalCharValue.data.approved === '' || modalCharValue.data.approved === null || modalCharValue.data.approved === undefined"
              @click="saveCharVal()">
              <template v-if="modalCharValue.onLoad" #icon>
                <i class="fas fa-spinner fa-spin me-2"></i>
              </template>
            </ButtonPrime>
          </div>
        </template>
      </DialogPrime>

      <!-- Modal Replace Char Val -->
      <DialogPrime v-model:visible="modalReplace.visible" header="Replace Char Value"
        style="width: 35rem; margin: 10px;">
        <div class="mb-2">
          <label for="existing_char_val_modal">Find what <span class="text-danger">*</span></label>
          <InputText id="existing_char_val_modal" v-model="modalReplace.data.val_abbrev_existing"
            placeholder="Fill with existing char val"
            :class="modalReplace.errorMessage['val_abbrev_existing'] && modalReplace.data.val_abbrev_existing === '' ? 'border-danger' : ''"
            fluid />
          <small v-if="modalReplace.errorMessage['val_abbrev_existing'] && modalReplace.data.val_abbrev_existing == ''"
            class="text-danger">{{ modalReplace.errorMessage['val_abbrev_existing'] }}</small>
        </div>
        <div class="">
          <label for="desired_val_modal">Replace with </label>
          <InputText id="desired_val_modal" v-model="modalReplace.data.val_abbrev_desiredVal"
            placeholder="Fill with desired char val" fluid />
        </div>
        <template #footer>
          <div class="d-flex justify-content-end gap-2 pt-3 border-top w-100 mt-2 px-1">
            <ButtonPrime type="button" label="Cancel" severity="danger" raised size="small" class="px-4 border-0"
              :disabled="modalReplace.onLoad" @click="modalReplace.visible = false" />
            <ButtonPrime type="button" severity="contrast" raised size="small" label="Save Client" class="px-4"
              :disabled="modalReplace.onLoad || !modalReplace.data.val_abbrev_existing" @click="replaceCharVal()">
              <template v-if="modalReplace.onLoad" #icon>
                <i class="fas fa-spinner fa-spin me-2"></i>
              </template>
            </ButtonPrime>
          </div>
        </template>
      </DialogPrime>

      <!-- Modal update material po text di char value -->
      <DialogPrime v-model:visible="modalBulkCharValPoText.visible" modal header='Update Char Value'
        style="width: 30rem; margin: 10px;">
        <div class="">
          <small>Are you sure you want to update all char values?</small>
        </div>
        <template #footer>
          <div class="d-flex justify-content-end gap-2 pt-3 border-top w-100 mt-2 px-1">
            <ButtonPrime type="button" label="Cancel" severity="danger" raised size="small" class="px-4 border-0"
              :disabled="modalBulkCharValPoText.onLoad" @click="modalBulkCharValPoText.visible = false"></ButtonPrime>
            <ButtonPrime type="button" severity="contrast" raised size="small" label="Save" class="px-4"
              :disabled="modalBulkCharValPoText.onLoad" @click="updateCharVal()">
              <template v-if="modalBulkCharValPoText.onLoad" #icon>
                <i class="fas fa-spinner fa-spin me-2"></i>
              </template>
            </ButtonPrime>
          </div>
        </template>
      </DialogPrime>
    </div>
  </div>
  <NoAccess v-else />
</template>

<script>
// import { dummyGetItemName, dummyGetCharItemName, dummyGetCharMaster, dummyGetCharVal } from './dummyValueCharItemName.js';
import { mapState } from "vuex";
import NoAccess from "@/components/NoAccess.vue";
import api from '@/helpers/api';
import standarItemNameService from '@/services/dictionary/standarItemNameService';
import characteristicItemNameService from '@/services/dictionary/characteristicItemNameService';
import characteristicService from "@/services/dictionary/characteristicService"
import ApiSearchableSelect from '@/components/ApiSearchableSelect.vue';

export default {
  components: {
    ApiSearchableSelect,
    NoAccess,
  },
  data() {
    return {
      standarItemNameService,
      characteristicItemNameService,
      searchTimeout: null,
      charValueSuggestions: [],
      table: {
        searchItemName: "",
        assignedInc: "",
        total: 3,
        data: [],
        onLoad: false,
        limit: 100,
        page: {
          current_page: 1,
          per_page: 100,
          total_page: 1
        },
      },
      tableCharVal: {
        searchCharVal: "",
        total: 3,
        data: [],
        // data: dummyGetCharVal,
        onLoad: false,
        onLoadUpdateCinVal: false,
        limit: 100,
        page: {
          current_page: 1,
          per_page: 100,
          total_page: 1
        },
      },
      selectedCharItemName: null,
      metaKey: null,
      itemTypeFilter: 'GEN',
      selectedDetail: null,
      selectedLanguage: null,
      optStandardItemName: {
        data: [],
        limit: 100,
      },
      optCharMaster: [],
      filterOptions: [
        { label: "ALL", command: () => this.changeItemType("ALL") },
        { label: "GEN", command: () => this.changeItemType("GEN") },
        { label: "OEM", command: () => this.changeItemType("OEM") },
        { label: "SERV", command: () => this.changeItemType("SERV") },
      ],
      CharValOption: [
        { label: "All Values", command: () => this.getCharVal(this.tableCharVal.limit, this.tableCharVal.page.current_page, this.selectedCharItemName.code, false, false) },
        { label: "Empty Abbreviation", command: () => this.getCharVal(this.tableCharVal.limit, this.tableCharVal.page.current_page, this.selectedCharItemName.code, true, false) },
        { label: "Count Zero", command: () => this.getCharVal(this.tableCharVal.limit, this.tableCharVal.page.current_page, this.selectedCharItemName.code, false, true) },
      ],
      typeOptions: [
        { label: "GEN", value: "GEN" },
        { label: "OEM", value: "OEM" },
      ],
      bulkOptions: [
        { label: "Yes, update all", value: true },
        { label: "No, do not update all", value: false },
      ],
      mandatoryOptions: [
        { name: "YES", code: "YES" },
        { name: "NO", code: "NO" },
      ],
      statusOptions: [
        { label: "SAP", value: "sap" },
      ],
      sepatorOptions: [
        { name: ";", code: ";" },
      ],
      approvalOption: [
        { label: "Approved", value: 1 },
        { label: "Not Approved", value: 0 },
      ],
      modalChar: {
        visible: false,
        action: "",
        title: "",
        data: {},
        errorMessage: {},
        onLoad: false,
      },
      modalBulkPoText: {
        title: "Update Char Mass",
        visible: false,
        onLoad: false,
        data: {}
      },
      modalCharValue: {
        visible: false,
        action: "",
        title: "",
        data: {},
        errorMessage: {},
        onLoad: false,
      },
      modalBulkCharValPoText: {
        title: "Update Char Val Mass",
        visible: false,
        onLoad: false,
        data: {}
      },
      modalReplace: {
        visible: false,
        data: {},
        onLoad: false,
        errorMessage: {},
      }
    };
  },
  computed: {
    ...mapState({
      authUserPermissions: (state) => state.auth.userHasPermissions || [],
    }),
    anyEmptyVal() {
      const d = this.modalChar.data
      return (!d.characteristic_code_desc || !d.sequence || !d.sequence_shortdes || !d.separator || !d.is_mandatory || !d.type)
    }
  },
  mounted() {
    // Load from URL query
    const inc = this.$route.query.inc;
    if (this.hasAnyPermission('characteristic-item-name-view') && inc) {
      this.table.assignedInc = inc;
      this.getCin(this.table.limit, this.table.page.current_page, inc, this.itemTypeFilter);
    }
  },
  methods: {
    hasAnyPermission(...perms) {
      return perms.some((p) => this.authUserPermissions.includes(p));
    },
    onSearchCharValue() {
      // Debounce search
      clearTimeout(this.searchTimeout);
      this.searchTimeout = setTimeout(() => {
        if (this.tableCharVal.search && this.tableCharVal.search.length >= 2) {
          this.searchCharValueByQuery();
        } else if (!this.tableCharVal.search && this.selectedCharItemName) {
          // Clear search, reload original data
          this.getCharVal(this.tableCharVal.limit, 1, this.selectedCharItemName.code, false, false);
        }
      }, 500);
    },
    async searchCharValueByQuery() {
      if (!this.selectedCharItemName || !this.tableCharVal.search || this.tableCharVal.search.length < 2) {
        return;
      }

      try {
        this.tableCharVal.onLoad = true;
        const resp = await api(this, characteristicItemNameService.searchCinVal({
          cin_code: this.selectedCharItemName.code,
          characteristic_value: this.tableCharVal.search
        }), false);

        this.tableCharVal.data = resp.data.data || [];
        this.tableCharVal.total = resp.data.total || 0;
        this.tableCharVal.page = {
          current_page: resp.data.current_page || 1,
          per_page: resp.data.per_page || 15,
          total_page: resp.data.last_page || 1
        };
      } catch (error) {
        this.tableCharVal.data = [];
        this.tableCharVal.total = 0;
      } finally {
        this.tableCharVal.onLoad = false;
      }
    },
    onSelectItemName(value) {
      if (!value) {
        this.table.assignedInc = null;
        this.table.data = [];
        this.selectedCharItemName = null;
        this.tableCharVal.data = [];
        this.$router.push({ query: null });
        return;
      }

      this.table.assignedInc = value.split(' - ')[0]; // Extract INC from "INC - Item Name"
      this.$router.push({ query: { inc: this.table.assignedInc } });
      this.getCin(this.table.limit, this.table.page.current_page, this.table.assignedInc, this.itemTypeFilter);
    },
    async getCin(limit, page, inc, type = "") {
      this.table.onLoad = true
      try {
        const params = { limit: limit, page: page, inc: inc, sort_by: 'sequence', sort_order: 'asc' };
        if (type && type !== 'ALL') {
          params.item_type = type;
        }
        const respGetCin = await api(this, characteristicItemNameService.listByItemName(params), false)
        this.table.data = respGetCin.data.data
        this.table.total = respGetCin.data.total
        this.table.page.current_page = respGetCin.data.current_page
        this.table.page.per_page = respGetCin.data.per_page
        this.table.page.total_page = respGetCin.data.last_page
      } catch (error) {
        this.table.data = []
        this.table.total = 0
      } finally {
        this.table.onLoad = false
      }
    },
    openAddModalChar() {
      this.modalChar = {
        visible: true,
        action: "create",
        title: "Add Characteristic Item Name",
        data: { code: "", sequence: "", sequence_shortdes: "", inc: "", characteristic_code: "", type: "", separator: ";", status: "active", is_mandatory: "NO", class_code: "", characteristic: "", characteristic_code_desc: "", selectedChar: null },
        errorMessage: {},
        onLoad: false,
      }
    },
    saveChar() {
      let isValid = this.validatorForm("Char", this.modalChar.data);
      if (!isValid) return false;

      this.modalChar.onLoad = true
      setTimeout(async () => {
        try {
          const d = this.modalChar.data
          const payload = {
            code: d.code,
            sequence: d.sequence,
            sequence_shortdes: d.sequence_shortdes,
            inc: d.inc,
            type: d.type,
            separator: d.separator,
            status: d.status,
            is_mandatory: d.is_mandatory,
            characteristic: d.characteristic
          }
          await api(this, characteristicItemNameService.create(payload))
          this.modalChar.data = {}
          this.modalChar.visible = false
          this.getCin(this.table.limit, this.table.page.current_page, this.table.assignedInc, this.itemTypeFilter)
        } catch (error) {
          this.handleErrorObjectNested(error)
        } finally {
          this.modalChar.onLoad = false
        }
      }, 500)
    },
    openModalUpdateChar() {
      this.modalBulkPoText = {
        visible: true,
        onLoad: false,
        data: { update_material_texts: true, items: [] }, // Tobe confirm team heads
      }
    },
    updateBulk() {
      this.table.onLoad = true
      this.modalBulkPoText.onLoad = true
      setTimeout(async () => {
        try {
          this.modalBulkPoText.data.items = this.table.data.map(row => ({
            id: row.id,
            code: row.code,
            sequence: row.sequence,
            sequence_shortdes: row.sequence_shortdes,
            inc: row.inc,
            characteristic_code: row.characteristic_code,
            type: row.type,
            separator: row.separator,
            status: row.status || 'ACTIVE',
            is_mandatory: row.is_mandatory || 'NO',
            class_code: row.class_code
          }))
          await api(this, characteristicItemNameService.updateBulk(this.modalBulkPoText.data))
          this.getCin(this.table.limit, this.table.page.current_page, this.table.assignedInc, this.itemTypeFilter)
          this.modalBulkPoText.visible = false
        } catch (error) {
          this.handleErrorObjectNested(error)
        } finally {
          this.modalBulkPoText.onLoad = false
          this.table.onLoad = false
        }
      }, 500)
    },
    deleteCharItemName(id) {
      this.confirmDialog("You won't be able to revert this!", "delete").then((result) => {
        if (result.isConfirmed) {
          this.table.onLoad = true
          api(this, characteristicItemNameService.delete(id)).then(() => { this.getCin(this.table.limit, this.table.page.current_page, this.table.assignedInc, this.itemTypeFilter) }).catch(() => { this.table.onLoad = false })
        }
      });
    },
    async filterCharMaster(event) {
      // User is typing → reset previously picked values and search if length >= 3
      if (event.originalEvent instanceof InputEvent) {
        Object.assign(this.modalChar.data, {
          code: "", characteristic_code: "", characteristic: "", class_code: "", characteristic_code_desc: ""
        })
        const keyword = (event.value || "").toUpperCase()
        if (keyword.length < 3) {
          this.optCharMaster = []
          return
        }
        try {
          const response = await api(this, characteristicService.list({ limit: 100, page: 1, select: 1, search: keyword }), false)
          this.optCharMaster = response.data.data
        } catch (error) {
          this.optCharMaster = []
        }
        return
      }
      // User picked an option → auto-fill dependent fields
      if (event.value && typeof event.value === 'object') {
        const inc = this.table.assignedInc
        Object.assign(this.modalChar.data, {
          code: `${event.value.code}_${inc}`,
          characteristic_code: event.value.code,
          characteristic: event.value.characteristic,
          class_code: `${event.value.char_sap}_${inc}`,
          inc,
          characteristic_code_desc: `${event.value.code} - ${event.value.characteristic}`
        })
      }
    },
    changeItemType(val) {
      this.itemTypeFilter = val
      this.getCin(this.table.limit, this.table.page.current_page, this.table.assignedInc, val)
    },
    getValFromCertRow() {
      if (!this.hasAnyPermission('characteristic-item-name-view-char-value')) return;
      this.getCharVal(this.tableCharVal.limit, this.tableCharVal.page.current_page, this.selectedCharItemName.code, false, false)
    },
    async getCharVal(limit, page, cinCode, emptyAbbrev, countZero = false) {
      this.tableCharVal.onLoad = true
      try {
        const respCharVal = await api(this, characteristicItemNameService.listCinValByCinCode(cinCode, { limit: limit, page: page, emptyAbbrev: emptyAbbrev, countZero: countZero }), false)
        this.tableCharVal.data = respCharVal.data.data
        this.tableCharVal.total = respCharVal.data.total
        this.tableCharVal.page.current_page = respCharVal.data.current_page
        this.tableCharVal.page.per_page = respCharVal.data.per_page
        this.tableCharVal.page.total_page = respCharVal.data.last_page
      } catch (error) {
        this.tableCharVal.data = []
        this.tableCharVal.total = 0
      } finally {
        this.tableCharVal.onLoad = false
      }
    },
    async searchCharValueForRow(event) {
      if (!event.query || event.query.length < 2) {
        this.charValueSuggestions = []
        return
      }
      try {
        const resp = await api(this, characteristicItemNameService.searchCinVal({
          characteristic_value: event.query
        }), false)
        this.charValueSuggestions = (resp.data.data || []).map(item => item.characteristic_value)
      } catch (error) {
        this.charValueSuggestions = []
      }
    },
    deleteItemCharVal(id) {
      this.confirmDialog("You won't be able to revert this!", "delete").then((result) => {
        if (result.isConfirmed) {
          this.tableCharVal.onLoad = true
          api(this, characteristicItemNameService.deleteCinVal(id)).then(() => { this.getCharVal(this.tableCharVal.limit, this.tableCharVal.page.current_page, this.selectedCharItemName.code, false, false) }).catch(() => { this.tableCharVal.onLoad = false })
        }
      });
    },
    openAddCharValModal() {
      this.modalCharValue = {
        visible: true,
        action: "create",
        title: "Add New Char Value",
        data: { cin_code: this.selectedCharItemName.code, characteristic_value: "", abbreviation: "", approved: "" },
        errorMessage: {},
        onLoad: false,
      }
    },
    saveCharVal() {
      let isValid = this.validatorForm("CharVal", this.modalCharValue.data);
      if (!isValid) return false;

      this.modalCharValue.onLoad = true
      setTimeout(async () => {
        try {
          await api(this, characteristicItemNameService.createCinVal(this.modalCharValue.data))
          this.modalCharValue.data = {}
          this.modalCharValue.visible = false
          this.getCharVal(this.tableCharVal.limit, this.tableCharVal.page.current_page, this.selectedCharItemName.code, false, false)
        } catch (error) {
          this.handleErrorObjectNested(error)
        } finally {
          this.modalCharValue.onLoad = false
        }
      }, 500)
    },
    openReplaceAbbrv() {
      this.modalReplace = {
        visible: true,
        data: { val_abbrev_existing: "", val_abbrev_desiredVal: "", update_material_texts: true },
        onLoad: false,
        errorMessage: {},
      }
    },
    replaceCharVal() {
      let isValid = this.validatorForm("replace", this.modalReplace.data)
      if (!isValid) return false

      this.tableCharVal.onLoad = true
      this.modalReplace.onLoad = true
      setTimeout(async () => {
        try {
          const payload = {
            val_abbrev_existing: this.modalReplace.data.val_abbrev_existing,
            val_abbrev_desiredVal: this.modalReplace.data.val_abbrev_desiredVal,
            update_material_texts: true
          }
          await api(this, characteristicItemNameService.replaceAbbrvCinVal(this.selectedCharItemName.code, payload))
          this.getCharVal(this.tableCharVal.limit, this.tableCharVal.page.current_page, this.selectedCharItemName.code, false, false)
          this.modalReplace.visible = false
        } catch (error) {
          this.handleErrorObjectNested(error)
        } finally {
          this.tableCharVal.onLoad = false
          this.modalReplace.onLoad = false
        }
      }, 500)
    },
    openModalUpdateCharVal() {
      this.modalBulkCharValPoText = {
        visible: true,
        onLoad: false,
        data: { update_material_texts: true, items: [] } // Tobe confirm team heads
      }
    },
    updateCharVal() {
      this.tableCharVal.onLoad = true
      this.modalBulkCharValPoText.onLoad = true
      setTimeout(async () => {
        try {
          this.modalBulkCharValPoText.data.items = this.tableCharVal.data.map(row => ({ ...row }))
          await api(this, characteristicItemNameService.updateBulkCinVal(this.modalBulkCharValPoText.data))
          this.getCharVal(this.tableCharVal.limit, this.tableCharVal.page.current_page, this.selectedCharItemName.code, false, false)
          this.modalBulkCharValPoText.visible = false
        } catch (error) {
          this.handleErrorObjectNested(error)
        } finally {
          this.modalBulkCharValPoText.onLoad = false
          this.tableCharVal.onLoad = false
        }
      }, 500)
    },
    copyCharVal(rowData) {
      if (rowData && rowData.characteristic_value) {
        rowData.abbreviation = rowData.characteristic_value;
      }
    },
    validatorForm(submenu, value) {
      let isValid = true;

      if (submenu === 'Char') {
        const requiredField = [
          { key: "characteristic_code_desc", errorKey: "characteristic", message: "Characteristic Master" },
          { key: "sequence", message: "Sequence" },
          { key: "sequence_shortdes", message: "Seq Shortdesc" },
          { key: "separator", message: "Separator" },
          { key: "is_mandatory", message: "Mandatory" },
          { key: "type", message: "Type" },
          { key: "status", message: "Status" }
        ]
        requiredField.forEach((val) => {
          if (!value[val.key]) {
            this.modalChar.errorMessage[val.errorKey || val.key] = `${val.message} is required`
            isValid = false
          }
        })
      } else if (submenu === 'CharVal') {
        if (!value.characteristic_value) {
          this.modalCharValue.errorMessage.characteristic_value = 'Sample Answer is required'
          isValid = false
        }
        if (value.approved === '' || value.approved === null || value.approved === undefined) {
          this.modalCharValue.errorMessage.approved = 'Approved is required'
          isValid = false
        }
      } else if (submenu === 'replace') {
        if (!value.val_abbrev_existing) {
          this.modalReplace.errorMessage.val_abbrev_existing = "Find what is required"
          isValid = false
        }
      }

      return isValid
    },
    handleErrorObjectNested(error) {
      if (error.response?.data?.code == 400 || error.response?.status == 422 || error.response?.status == 500) {
        const errorData = error.response?.data?.data;

        if (typeof errorData === 'object' && errorData !== null) {
          for (const key in errorData) {
            if (Object.prototype.hasOwnProperty.call(errorData, key)) {
              const match = key.match(/^items\.(\d+)\.(.+)$/);
              if (match) {
                error.response.data.data[key].forEach(message => {
                  this.$toastNotifPrime('error', error.response.data.message, `${message} in row ${parseInt(match[1]) + 1}`)
                })
              } else {
                this.$toastNotifPrime('error', error.response.data.message, errorData[key]);
              }
            }
          }
        }
      }
    },
    changePage(val) {
      if (val === 'char') {
        this.table.onLoad = true;
        setTimeout(() => {
          this.getCin(this.table.limit, this.table.page.current_page, this.table.assignedInc, this.itemTypeFilter)
        }, 100);
      } else if (val === 'char_val') {
        this.tableCharVal.onLoad = true;
        setTimeout(() => {
          this.getCharVal(this.tableCharVal.limit, this.tableCharVal.page.current_page, this.selectedCharItemName.code, false, false)
        }, 100);
      }
    },
    rowClass(rowData) {
      return this.selectedCharItemName && this.selectedCharItemName.code === rowData.code ? 'selected-row' : '';
    },
  },
};
</script>
<style scoped>
::v-deep(.selected-row) {
  background-color: #FFE391 !important;
  color: rgb(22, 19, 19) !important;
}

::v-deep(.p-select-label),
::v-deep(.p-select-option) {
  font-size: 0.875rem !important;
}

/* Padding horizontal header & body dibuat sama untuk kedua tabel, kalau tidak
   input jadi lebih lebar dari tulisan header-nya (default .datatable-sm
   1.25rem hanya kena header). */
::v-deep(.char-table .p-datatable-thead > tr > th.bg-light),
::v-deep(.char-val-table .p-datatable-thead > tr > th.bg-light) {
  padding-left: 0.5rem !important;
  padding-right: 0.5rem !important;
}
::v-deep(.char-table .p-datatable-tbody > tr > td),
::v-deep(.char-val-table .p-datatable-tbody > tr > td) {
  padding: 2px 0.5rem !important;
}
/* Header sticky: background solid + z-index supaya baris tidak tembus saat scroll */
::v-deep(.char-table .p-datatable-thead > tr > th),
::v-deep(.char-val-table .p-datatable-thead > tr > th) {
  position: sticky !important;
  top: 0;
  z-index: 2;
  background-color: #f6f9fc !important;
}
/* Kolom sempit (checkbox M & panah) tanpa padding horizontal.
   Tambahkan class `col-narrow` di header-class & body-class pada Column-nya. */
::v-deep(.p-datatable-thead > tr > th.col-narrow),
::v-deep(.p-datatable-tbody > tr > td.col-narrow) {
  padding-left: 0 !important;
  padding-right: 0 !important;
}
/* Jaga input tetap di dalam cell-nya */
::v-deep(.table-input-select) {
  max-width: 100% !important;
  box-sizing: border-box !important;
}
/* For InputText (SEQ & SEQ SHORTDES) */
::v-deep(.table-input-select.p-inputtext) {
  width: 100% !important;
  font-size: 0.75rem !important;
  padding: 0.2rem 0.35rem !important;
}
/* For SelectPrime (Separator) */
::v-deep(.table-input-select.p-select) {
  width: 100% !important;
}
::v-deep(.table-input-select .p-select-label) {
  font-size: 0.75rem !important;
  padding: 0.2rem 0.35rem !important;
}
::v-deep(.table-input-select .p-select-trigger) {
  width: 1.5rem !important;
}

/* For AutoComplete */
::v-deep(.table-input-select.p-autocomplete) {
  width: 100% !important;
}
::v-deep(.table-input-select .p-autocomplete-input) {
  font-size: 0.75rem !important;
  padding: 0.2rem 0.35rem !important;
  width: 100% !important;
}

/* Smaller circle, icon stays original size */
::v-deep(.btn-trash-xs) {
  width: 1.7rem !important;
  height: 1.7rem !important;
  padding: 0 !important;
}

/* Default rata kiri. Kolom yang mau center cukup tambah class `text-center`
   di header-class & body-class pada Column-nya (tanpa selector nth-child). */
::v-deep(.p-datatable-thead > tr > th) {
  text-align: left;
}
::v-deep(.p-datatable-tbody > tr > td) {
  text-align: left;
}
/* Label header dibungkus flex container, jadi yang menentukan justify-content,
   bukan text-align. Class-nya .p-datatable-column-header-content (PrimeVue 4.x). */
::v-deep(.p-datatable-thead > tr > th.text-center .p-datatable-column-header-content) {
  justify-content: center;
}
</style>